// extracted by mini-css-extract-plugin
export default {"container":"LoadingIndicator_container__m68+t"};